import React from 'react'
import ResourceProfile from './resource-profile.component'
import { ResourceProfileStoreProvider } from './resource-profile.context'

const ResourceProfileWrapper = (props) => {
  return (
    <ResourceProfileStoreProvider>
      <ResourceProfile {...props} />
    </ResourceProfileStoreProvider>
  )
}

export default ResourceProfileWrapper
